import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';

import CancellationZHHK from '../../components/10General/Cancellation_zh_HK';
import CancellationENUS from '../../components/10General/Cancellation_en_US';
import {getTnc} from "../../utils/04Api/Tnc";

class Cancellation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cancellation: null,
        }
    }

    componentDidMount() {

        this.ApiGetCancellation(this.ApiGetCancellation);
    }

    ApiGetCancellation = (errorCallback) => {

        let callback = (res) => {

            if (res.status === 200) {

                this.setState({
                    ...this.state,
                    cancellation: res.body
                })
            }
        }

        getTnc('service_termination_policy', callback, errorCallback);
    }

    render() {

        const {
            t,
            i18n
        } = this.props;

        // console.log(this.state.cancellation);

        return (
            <div className="wrapper-container media">

                <div className="page-title"><h2>{t("Menu.CancellationPolicy")}</h2></div>

                <div className="sep-0"/>

                <div className="containerMain">
                    <div className="content clearfix">
                        {i18n.language === 'zh-HK'
                            ? this.state.cancellation !== null ?
                                <CancellationZHHK
                                    content={this.state.cancellation['zh-hk'].stp_content_chi.value}/> : ''
                            : this.state.cancellation !== null ?
                                <CancellationENUS
                                    content={this.state.cancellation['en-us'].stp_content_eng.value}/> : ''
                        }
                    </div>
                </div>
            </div>
        );
    }
}

// const mapStateToProps = (state) => (
// 	{
// 	}
// );

export default withTranslation()(Cancellation);
